<!--begin::Subheader-->
<div class="subheader py-2 pb-1 pt-1" id="kt_subheader">
    <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap container-fluid">
        <!--begin::Info-->
        <div class="d-flex align-items-center flex-wrap me-1">
            <ng-container *ngIf="subheaderMobileToggle">
                <!--begin::Mobile Toggle-->
                <button class="burger-icon burger-icon-left me-4 d-inline-block d-lg-none" id="kt_subheader_mobile_toggle">
                    <span></span>
                </button>
                <!--end::Mobile Toggle-->
            </ng-container>

            <!--begin::Page Heading-->
            <div class="d-flex flex-column">
                <!--begin::Page Title-->
                <ng-container>
                    <h2 class="text-white font-weight-bold my-2 me-5" style="font-size: 30px">
                        <!-- {{ _title }} -->
                        <a class="inactive-icon"><img [src]="imgSrc" alt="" (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()" /></a>
                        Administration
                    </h2>
                </ng-container>
            </div>
            <!--end::Page Heading-->
        </div>
        <!--end::Info-->

        <!--begin::Toolbar-->

        <!--end::Toolbar-->
    </div>
</div>
<!--end::Subheader-->
